import { gql } from "@apollo/client";

export const componentQuery = gql`
  query campus($scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      components {
        items {
          id
          code
          name
        }
      }
    }
  }
`;
